module.exports = __webpack_public_path__ + "static/img/map6_relation.8b6c388.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/map6_relation.jpg
// module id = NoFK
// module chunks = 1